import { Component, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import {
  RadioQuestionModel,
  SelectQuestionModel,
  ExplainQuestionModel,
} from '../../../viewmodels/policy-item.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'permit-template-policy',
  templateUrl: './permit.component.html',
})
export class PermitTemplateComponent implements OnChanges, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  @Input() permitId: string;
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  permitData: {
    radioText: string;
    selectText: string;
    explainTitleText: string;
    explainOptionText: string;
    exampleText: string;
    explainActiveOptions: Array<string>;
  };
  reconsider = new RadioQuestionModel();
  cacellation = new SelectQuestionModel();
  explain = new ExplainQuestionModel();

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnChanges() {
    this.setPermitDetails();
    this.setReconsiderQuestion();
    this.setCancellationQuestion();
    this.setExplainQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setPermitDetails() {
    if (this.permitId === 'payDisplay') {
      this.permitData = {
        radioText: 'I had a valid pay & display ticket',
        selectText: 'pay & display ticket holders who fail to display their ticket correctly?',
        explainTitleText: 'pay & display tickets',
        explainOptionText: 'Pay & Display',
        exampleText: 'Pay & Display tickets',
        explainActiveOptions: ['0', '1', '2', '3', '4', '6', '7', '8', '9', '10'],
      };
    } else if (this.permitId === 'business') {
      this.permitData = {
        radioText: 'I had a valid business permit',
        selectText: 'business permit holders who fail to display their permit correctly?',
        explainTitleText: 'business permits',
        explainOptionText: 'Business permit holders',
        exampleText: 'Business permits',
        explainActiveOptions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      };
    } else if (this.permitId === 'contract') {
      this.permitData = {
        radioText: 'I had a valid contract permit',
        selectText: 'contract permit holders who fail to display their permit correctly?',
        explainTitleText: 'contract permits',
        explainOptionText: 'Contract permit holders',
        exampleText: 'Contract permits',
        explainActiveOptions: ['0', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      };
    } else if (this.permitId === 'doctors') {
      this.permitData = {
        radioText: "I had a valid doctor's permit",
        selectText: "doctor's permit holders who fail to display their permit correctly ?",
        explainTitleText: "doctors' permits",
        explainOptionText: 'Doctor permit holders',
        exampleText: "Doctors' permits",
        explainActiveOptions: ['0', '1', '2', '4', '5', '6', '7', '8', '9', '10'],
      };
    } else if (this.permitId === 'marketTraders') {
      this.permitData = {
        radioText: "I had a valid market trader's permit",
        selectText: "market trader's permit holders who fail to display their permit correctly?",
        explainTitleText: "market traders' permits",
        explainOptionText: 'Market trader permit holders',
        exampleText: "Market traders' permits",
        explainActiveOptions: ['0', '1', '2', '3', '5', '6', '7', '8', '9', '10'],
      };
    } else if (this.permitId === 'seasonTicket') {
      this.permitData = {
        radioText: 'I had a valid season ticket',
        selectText: 'season ticket holders who fail to display their season ticket correctly?',
        explainTitleText: 'season tickets',
        explainOptionText: 'Season ticket holders',
        exampleText: 'Season tickets',
        explainActiveOptions: ['0', '1', '2', '3', '4', '5', '6', '8', '9', '10'],
      };
    }
  }

  setReconsiderQuestion() {
    this.reconsider.data = {
      title: `Reconsider if a driver says '${this.permitData.radioText}' and can prove it (eg by sending it in)?`,
      includeTitle: true,
      answers: [
        { text: 'yes', value: 'y' },
        { text: 'yes – provided it was displayed (even if it was wrongly displayed)', value: 'd' },
        { text: 'no', value: 'n' },
      ],
    };
  }
  onReconsiderSelected(answerValue) {
    this.reconsider.valueSelected = answerValue;
  }

  setCancellationQuestion() {
    this.cacellation.data = {
      title: `How many goodwill PCN cancellations for ${this.permitData.selectText}`,
      includeTitle: true,
      answers: [
        { id: '0', value: '1' },
        { id: '1', value: '2' },
        { id: '2', value: '3' },
      ],
    };
  }
  onCancellationSelected(answerValue) {
    this.cacellation.valueSelected = answerValue;
  }

  setExplainQuestion() {
    this.explain = {
      data: {
        title: `When drivers use ${this.permitData.explainTitleText} in wrong bays,
                how would you like Response Master to explain where they can be used?`,
        includeTitle: true,
        name: `'${this.permitData.explainOptionText}'`,
        validList: this.permitData.explainActiveOptions,
        exampleItem: this.permitData.exampleText,
      },
      active: true,
      valueSelected: '1',
      validationSelected: '6',
      validationText: 'text',
    };
  }
  onExplainQuestionSelected(answerValue) {
    this.explain.valueSelected = answerValue.answerSelected;
    this.explain.validationSelected = answerValue.validationSelected;
    this.explain.validationText = answerValue.validationText;
  }

  setSelectedValues() {
    if (this.permitId === 'payDisplay') {
      this.reconsider.valueSelected = this.policiesAnswers['4_1'];
      this.cacellation.valueSelected = this.policiesAnswers['4_2'];
      this.explain.validationSelected = this.policiesAnswers['4_4'];
      this.explain.valueSelected = this.policiesAnswers['4_3'];
      this.explain.validationText = this.policiesAnswers['4_5'];
    } else if (this.permitId === 'business') {
      this.reconsider.valueSelected = this.policiesAnswers['6_2'];
      this.cacellation.valueSelected = this.policiesAnswers['6_3'];
      this.explain.validationSelected = this.policiesAnswers['6_5'];
      this.explain.valueSelected = this.policiesAnswers['6_4'];
      this.explain.validationText = this.policiesAnswers['6_6'];
    } else if (this.permitId === 'contract') {
      this.reconsider.valueSelected = this.policiesAnswers['24_2'];
      this.cacellation.valueSelected = this.policiesAnswers['24_3'];
      this.explain.validationSelected = this.policiesAnswers['24_5'];
      this.explain.valueSelected = this.policiesAnswers['24_4'];
      this.explain.validationText = this.policiesAnswers['24_6'];
    } else if (this.permitId === 'doctors') {
      this.reconsider.valueSelected = this.policiesAnswers['7_2'];
      this.cacellation.valueSelected = this.policiesAnswers['7_3'];
      this.explain.validationSelected = this.policiesAnswers['7_5'];
      this.explain.valueSelected = this.policiesAnswers['7_4'];
      this.explain.validationText = this.policiesAnswers['7_6'];
    } else if (this.permitId === 'marketTraders') {
      this.reconsider.valueSelected = this.policiesAnswers['8_2'];
      this.cacellation.valueSelected = this.policiesAnswers['8_3'];
      this.explain.validationSelected = this.policiesAnswers['8_5'];
      this.explain.valueSelected = this.policiesAnswers['8_4'];
      this.explain.validationText = this.policiesAnswers['8_6'];
    } else if (this.permitId === 'seasonTicket') {
      this.reconsider.valueSelected = this.policiesAnswers['25_2'];
      this.cacellation.valueSelected = this.policiesAnswers['25_3'];
      this.explain.validationSelected = this.policiesAnswers['25_5'];
      this.explain.valueSelected = this.policiesAnswers['25_4'];
      this.explain.validationText = this.policiesAnswers['25_6'];
    }
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    if (this.permitId === 'payDisplay') {
      policyList = [
        { id: '4_1', description: this.reconsider.valueSelected },
        { id: '4_2', description: this.cacellation.valueSelected },
        { id: '4_4', description: this.explain.validationSelected },
        { id: '4_3', description: this.explain.valueSelected },
        { id: '4_5', description: this.explain.validationText },
      ];
    } else if (this.permitId === 'business') {
      policyList = [
        { id: '6_2', description: this.reconsider.valueSelected },
        { id: '6_3', description: this.cacellation.valueSelected },
        { id: '6_5', description: this.explain.validationSelected },
        { id: '6_4', description: this.explain.valueSelected },
        { id: '6_6', description: this.explain.validationText },
      ];
    } else if (this.permitId === 'contract') {
      policyList = [
        { id: '24_2', description: this.reconsider.valueSelected },
        { id: '24_3', description: this.cacellation.valueSelected },
        { id: '24_5', description: this.explain.validationSelected },
        { id: '24_4', description: this.explain.valueSelected },
        { id: '24_6', description: this.explain.validationText },
      ];
    } else if (this.permitId === 'doctors') {
      policyList = [
        { id: '7_2', description: this.reconsider.valueSelected },
        { id: '7_3', description: this.cacellation.valueSelected },
        { id: '7_5', description: this.explain.validationSelected },
        { id: '7_4', description: this.explain.valueSelected },
        { id: '7_6', description: this.explain.validationText },
      ];
    } else if (this.permitId === 'marketTraders') {
      policyList = [
        { id: '8_2', description: this.reconsider.valueSelected },
        { id: '8_3', description: this.cacellation.valueSelected },
        { id: '8_5', description: this.explain.validationSelected },
        { id: '8_4', description: this.explain.valueSelected },
        { id: '8_6', description: this.explain.validationText },
      ];
    } else if (this.permitId === 'seasonTicket') {
      policyList = [
        { id: '25_2', description: this.reconsider.valueSelected },
        { id: '25_3', description: this.cacellation.valueSelected },
        { id: '25_5', description: this.explain.validationSelected },
        { id: '25_4', description: this.explain.valueSelected },
        { id: '25_6', description: this.explain.validationText },
      ];
    }

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
